// extracted by mini-css-extract-plugin
export default {"assignConnectionModal":"styles_assignConnectionModal__jNnmf","submitBtn":"styles_submitBtn__TOr8-","agentRoleConfirmText":"styles_agentRoleConfirmText__TGlrQ"};